import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { processDetailViewComponentFactory } from 'src/app/modules/instance/factories/process-detail-view-component.factory';
import { ITaskModel } from 'src/app/shared/interfaces/task-model.interface';

@Component({
    standalone: false,
    selector: 'app-show-process-details-popup-button',
    templateUrl: './show-process-details-popup-button.component.html',
    styleUrls: ['./show-process-details-popup-button.component.scss']
})
export class ShowProcessDetailsPopupButtonComponent implements OnInit {
    @Input()
    public label: string;

    @Input()
    public process: ITaskModel;

    constructor(private readonly dialog: MatDialog) {}

    ngOnInit(): void {}

    checkProcessStatus(event: Event) {
        this.openTaskInfoDialog(this.process);
        event.stopPropagation();
    }

    openTaskInfoDialog(task: ITaskModel) {
        if (!task) {
            return;
        }
        const dialogConfig = new MatDialogConfig();

        dialogConfig.autoFocus = true;
        dialogConfig.data = task;
        dialogConfig.maxHeight = '900px';
        dialogConfig.maxWidth = '900px';

        this.dialog.open(processDetailViewComponentFactory(task.type), dialogConfig);
    }
}
